import { Base } from "../../../../../base/components/base"
import { Div } from "../../../../../base/components/native/div"
import services from "../../../../../services"
import { TArticle } from "../../../../../types/article"
import { ArticleItem } from "./article-item"
import { baseStyle } from "./article-item.style"
import { addNewArticleStyle, listStyle, titleStyle } from "./articles-list.style"

export const ArticlesList = () => {

    const base = Base()

    const title = Div('لیست صفحات')
    title.cssClass(titleStyle)
    base.append(title)

    const newArticle = Div('+ افزودن صفحه جدید')
    newArticle.cssClass(addNewArticleStyle)
    newArticle.el.onclick = () => base.emit('new')
    base.append(newArticle)

    const list = Div()
    list.cssClass(listStyle)
    base.append(list)

    list.append(Div('در حال دریافت لیست صفحات...'))

    const items: any[] = []
    services.articles.all().then(articles => {
        list.empty()
        articles.forEach((article: TArticle) => {
            const item = ArticleItem(article)
            item.on('select', (article: TArticle) => base.emit('select', article))
            items.push(item)
            list.append(item)
        })
        base.emit('loaded', articles)
    })

    return Object.assign(base, {
        add(article: TArticle) {
            const item = ArticleItem(article)
            item.on('select', (article: TArticle) => base.emit('select', article))
            list.prepend(item)
        },
        update(article: TArticle) {
            const found = items.find(item => item.getId() === article._id)
            console.log(found);

            if (found) {
                found.updateUrl(article.url.split('/').pop())
            }

        },
        remove(articleId: string) {
            const found = items.find(item => item.getId() === articleId)
            if (found) {
                found.remove()
            }

        }
    })
}